import { useContext } from 'react';
import {feature} from "../common/api/Models/FeatureConfiguration";
import PageContext from "../components/Common/PageContext";
import {
    isFeatureEnabledForLocationAndReceiveType,
    isFeatureEnabledForLocationReceiveTypeAndTransferReason
} from '../util/featureUtil';

type FeatureName =
    | 'arrivals'
    | 'adhocCreditRequest'
    | 'partReceive'
    | 'customerOrderAllocationAndAdvancement'
    | 'inboundLocationAssignment'
    | 'commercialAccountSelection'
    | 'productLabelAutoPrint'
    | 'productLabelAdhocPrint'
    | 'transfers'
    | 'skipCustomerOrderAllocation'
    | 'priorityStock'
    | 'captureFreightCost'
    | 'reverseCredit';

type FeatureCheckParams = {
  locationId: string | number | undefined;
  receiveType: string | undefined;
  transferReason?: string;
};

export const useFeatureCheck = (params : FeatureCheckParams) => {
    const [pageContext] = useContext(PageContext);
    const {
        featureConfiguration
    }: {
        featureConfiguration: { [Key in FeatureName]: feature; };
    } = pageContext;
    const { locationId, receiveType, transferReason } = params;
    
    /*
    * Returns true if the feature is enabled for the given location and receive type.
    */
  const isFeatureEnabled = (featureName: FeatureName) => {
        if (!locationId || !receiveType) return false;
      
        return isFeatureEnabledForLocationAndReceiveType(
            locationId,
            featureConfiguration[featureName],
            receiveType
        );
  };

    /*
    * Returns true if the feature is enabled for the given location, receive type and transfer reason.
    */
    const isFeatureEnabledForTransferReason = (featureName: FeatureName) => {
        if (!locationId || !receiveType) return false;

        return isFeatureEnabledForLocationReceiveTypeAndTransferReason(
            locationId,
            featureConfiguration[featureName],
            receiveType,
            transferReason
        );
    };
  
  return {
    isFeatureEnabled,
    isFeatureEnabledForTransferReason
  };
};